import React from 'react';

import Badge from '../common/Badge';
import { Card } from '@copilot/ui';

// Reused by both the System page's backend/database cards and its three
// provider cards - title + a status badge + optional label/value
// metadata rows. Badge variants reuse the existing listening (green) /
// disconnected (red) tokens from styles/tokens.css - no new colors.
function AdminStatusCard({ title, statusLabel, isPositive, metadata = [] }) {
  return (
    <Card interactive className="admin-status-card">
      <div className="admin-status-card-header">
        <span className="stat-card-label">{title}</span>
        <Badge variant={isPositive ? 'listening' : 'disconnected'}>
          {statusLabel}
        </Badge>
      </div>

      {metadata.length > 0 && (
        <dl className="admin-status-meta">
          {metadata.map(({ label, value }) => (
            <div key={label} className="admin-status-meta-row">
              <dt>{label}</dt>
              <dd>{value ?? '—'}</dd>
            </div>
          ))}
        </dl>
      )}
    </Card>
  );
}

export default AdminStatusCard;
